module.exports = __webpack_public_path__ + "img/SMP_profil-121154500-1400x900.598d2863.jpg";